"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import { CarouselBlock } from "@/scott/ui/blocks/carousel/carousel";
import { ContentBlocks } from "./content-blocks";
import type { ContentSliderBlockProps } from "./content-slider-block";

export function ContentSliderBlockPreview(
  props: Readonly<ContentSliderBlockProps>
) {
  const inspector = useContentfulInspectorMode();

  const slides = props.slides.map((block, index) => ({
    id: block.id ?? `${props.id}-slide-${index}`,
    content: (
      <ContentBlocks
        blocks={[block]}
        disablePreviewInspector
        pageContext={props.pageContext}
      />
    ),
    inspectorProps:
      inspector({
        entryId: block.sys?.id ?? undefined,
        fieldId: "internalName",
      }) ?? undefined,
  }));

  return (
    <CarouselBlock
      {...props}
      inspectorProps={{
        container:
          inspector({
            entryId: props.sys?.id ?? undefined,
            fieldId: "internalName",
          }) ?? undefined,
      }}
      mode="D2C"
      slides={slides}
    />
  );
}
